import { IState } from 'shared/store';

// TODO: Удалить в CD-226224.Онбординги на месяц.
export function selectWasChatOpened(state: IState) {
  return state.chatOnboarding.wasChatOpened;
}
